import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import SimulationPage from './pages/SimulationPage';
import SimulationResults from './pages/SimulationResults';
import ParetoAnalysis from './pages/ParetoAnalysis';
import CreatePortfolio from './pages/CreatePortfolio';
import CreateOptimization from './pages/CreateOptimization';
import AuthButton from './components/AuthButton';
import { initKeycloak } from './services/keycloak';
import './App.css';

function App() {
  const [keycloakReady, setKeycloakReady] = useState(false);

  useEffect(() => {
    // Initialize KeyCloak on app start
    initKeycloak(
      (token) => {
        console.log('KeyCloak initialized, token:', token ? 'present' : 'none');
        setKeycloakReady(true);
      },
      (error) => {
        console.error('KeyCloak init error:', error);
        setKeycloakReady(true); // Continue anyway for demo access
      }
    );
  }, []);

  if (!keycloakReady) {
    return <div className="loading">Initializing authentication...</div>;
  }

  return (
    <div className="App">
      <Router>
        <div className="app-header">
          <h1>TradeOffLab</h1>
          <AuthButton />
        </div>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/simulation" element={<SimulationPage />} />
          <Route path="/simulation-results" element={<SimulationResults />} />
          <Route path="/pareto" element={<ParetoAnalysis />} />
          <Route path="/create-portfolio" element={<CreatePortfolio />} />
          <Route path="/optimization/create" element={<CreateOptimization />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
